import Viewer from 'react-viewer';
const LightBoxGallery = ({ images, isOpen, setOpen }) => {
  return (
    <div>
      <button className="proj-btn ss-btn" type="button" onClick={() => setOpen(true)}>
        SCREENSHOT
      </button>
      {isOpen && (
        <Viewer
        visible={isOpen}
        onClose={() => { setOpen(false); } }
        images={images?.map(image => ({ src: image, alt: "" }))}
        />
      )}
    </div>
  );
};

export default LightBoxGallery;